import { Component } from '@angular/core';
import { StorageService } from './storage.service';
import { EventService } from './event.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'CarriersTMS';
  showRTL = false;
  showHeader = false;
  currentRoute= '';
  constructor(private storage: StorageService, private event: EventService, private translate: TranslateService, private router: Router) {
    const langChk = this.storage.getFromCookie('langPref');
    if (langChk && langChk != 'null') {
      translate.setDefaultLang(this.storage.getFromCookie('langPref'));
      this.showRTL = this.storage.getFromCookie('langPref') == 'ar';
    } else {
      translate.setDefaultLang('en');
    }
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: NavigationEnd) => {
      this.currentRoute = event.url;
      this.showHeaderCheck();
    });
    this.showHeaderCheck();
    this.event.accessTokenChanges().subscribe(
      data => this.showHeader = data
    );
    this.event.languageUpdateChanges().subscribe(
      data => {
        translate.use(data);
        this.showRTL = data == 'ar';
        // Set cookie prefs for next login
        this.storage.setCookie('langPref', data);
      }
    );
  }

  showHeaderCheck() {
    const access_token = this.storage.getFromCookie('access_token');
    if (access_token) {
      this.showHeader = true;
    }else{
      this.showHeader = false;
    }
    if (this.currentRoute.includes('requestCallBack')) {
      this.showHeader = false;
    }
  }
}
